import { z } from 'zod';

import zodLocales from 'common/zod/locales';

export const CARD_ALIAS_MAX_LENGTH = 80;
export const cardAliasFormSchema = z.object({
  alias: z
    .string()
    .trim()
    .max(CARD_ALIAS_MAX_LENGTH)
    .regex(/^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF0-9\s]*$/, {
      message: zodLocales.errors.alphanumericAndAccented,
    })
    .nullable(),
});
export type CardAliasFormSchema = z.infer<typeof cardAliasFormSchema>;
